// extracted by mini-css-extract-plugin
export default {"tile":"src-components-organisms-modals-tile-drawer-modal-tile-tile-module__tile--alcBA"};